import { motion } from "framer-motion"
import { useNavigate } from "react-router-dom"

export function CTASection() {
  const navigate = useNavigate()

  const handleGetStarted = () => {
    navigate('/auth/register')
  }

  return (
    <section className="py-32 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center bg-gradient-to-br from-blue-500 to-purple-600 rounded-[3rem] p-12 md:p-24 text-white shadow-2xl shadow-blue-500/30 relative overflow-hidden"
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-20">
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-white rounded-full blur-3xl" />
            <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-purple-400 rounded-full blur-3xl" />
          </div>
          
          <div className="relative z-10">
            <h2 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight">
              Ready to simplify everything?
            </h2>
            <p className="text-xl md:text-2xl text-blue-100 mb-10 max-w-2xl mx-auto">
              Join thousands who've already discovered the easier way to live digital.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={handleGetStarted}
                className="h-16 px-10 text-lg rounded-full bg-white text-blue-600 hover:bg-blue-50 shadow-xl transition-all hover:-translate-y-1 font-bold flex items-center justify-center"
                style={{ color: '#2563eb' }}
              >
                Get Started Free
              </button>
              <p className="text-sm text-blue-100 mt-4 sm:mt-0">
                Free forever • No credit card required
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
